import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, switchMap, throwError, of, filter, BehaviorSubject, catchError, map } from 'rxjs';
import { OccEndpointsService, UserIdService } from '@spartacus/core';
import { ApiResponse, GalleryImage, LocationData } from './location-data.model';
import { tap } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class ReturnsUkService {


  private apiNoreturnUrl = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/noReturnSubmit?fields=DEFAULT"`);
  private apiProductstoreturn = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/productsToReturn?fields=DEFAULT`);
  private apisubmitReturnsUrl = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/submitUKReturns?fields=DEFAULT`);
  //private apigetSeasonReturnOrders = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/getSeasonReturnOrders/${season}?fields=DEFAULT`);
  private apigetReturnbyLocation = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders`)
  private apigetSeason = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/seasonDropdownReturns/2023-2024?fields=DEFAULT`)
  asmenabled: boolean=false;
  showSorryMsg$= new BehaviorSubject<any>(false);
  mobimage$= new BehaviorSubject<string>("");
  rerunstream$= new BehaviorSubject<string>("");
  rerunqr$= new BehaviorSubject<any>(false);
  
  
  fetchUserUrl() {
    this.asmenabled = localStorage.getItem('showASM') === 'true';
    let partUrl = "/users/current";
    this.userIdService.getUserId().subscribe(item => {
      if(item && this.asmenabled){
        partUrl = `/users/${item}`;
      }else{
        localStorage.removeItem('isSearchByProfile')
      }
    });
    return partUrl;
  }
  setmodalimage(value: string) {
    this.mobimage$.next(value);
  }
  getmodalimage() {
    return this.mobimage$.asObservable();
  }
  setuploadmore(value: string) {
    this.rerunstream$.next(value);
  }
  getuploadmore() {
    return this.rerunstream$.asObservable();
  }
  setnewqr(obj: any) {
    this.rerunqr$.next(obj);
  }
  getnewqr() {
    return this.rerunqr$.asObservable();
  }
  getIsSearchByProfile(){
    if(localStorage.getItem('isSearchByProfile')  == 'false'){
      return false;
    }
    return true;
  }
  constructor(private http: HttpClient,private occ:OccEndpointsService,protected userIdService:UserIdService) {
    this.asmenabled = localStorage.getItem('showASM') === 'true';
   }
  private showDivSource = new BehaviorSubject<boolean>(false);
  currentShowDiv = this.showDivSource.asObservable();
  //private locationImages: { [key: string]: GalleryImage[] } = {};
  
private locationImages: Record<string, GalleryImage[]> = {};
private locationImageKeys: Record<string, Set<string>> = {}; // <-- key registry per location

  locationImageFiles: { [key: string]: File[] } = {};
  changeShowDiv(show: boolean) {
    this.showDivSource.next(show);
  }

  private showNewReturn = new BehaviorSubject<boolean>(false);
  currentShowStatus = this.showNewReturn.asObservable();
  private additionalReturnDataSubject = new BehaviorSubject<any>(null);
  additionalReturnData$ = this.additionalReturnDataSubject.asObservable();
  changeShowStatus(show: boolean) {
    this.showNewReturn.next(show);
  }

  getLocations(season:any): Observable<any> {
    const apiLocationreturnUrl = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/startNewReturn/${season}?fields=DEFAULT&isSearchByProfile=${this.getIsSearchByProfile()}`);

    return this.http.get(apiLocationreturnUrl)
  
  }

  getSeasonReturnOrders(season: string): Observable<any> {
    this.apigetReturnbyLocation = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders`)
    const apiUrl = `${this.apigetReturnbyLocation}/getSeasonReturnOrders/${season}?fields=DEFAULT`;
    return this.http.get<any>(apiUrl);
  }

  getReturnEligibility(season: string): Observable<any> {
    this.apigetReturnbyLocation = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders`)
    const apiUrl = `${this.apigetReturnbyLocation}/getMyReturnsInfo/${season}?fields=DEFAULT&isSearchByProfile=${this.getIsSearchByProfile()}`;
    return this.http.get<any>(apiUrl);
   }

  getAdditionalReturn(returnId: string, season: string): Observable<any> {
    this.apigetReturnbyLocation = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders`)
    const apiUrl = `${this.apigetReturnbyLocation}/additionalReturn?fields=DEFAULT&returnId=${returnId}&season=${season}`;
    return this.http.get<any>(apiUrl);
  }

  deleteDosesConsent(returnId: string) {
    this.apigetReturnbyLocation = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders`)
    const url = `${this.apigetReturnbyLocation}/deleteDosesConsent?fields=DEFAULT&returnId=${returnId}`;
    return this.http.get(url, { responseType: 'text' }).pipe(
      catchError(this.handleError) // Handle errors
    );;
  }

  setAdditionalReturnData(data: any): void {
    this.additionalReturnDataSubject.next(data);
  }

  getSeasons(): Observable<any> {
    this.apigetSeason = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/seasonDropdownReturns/2023-2024?fields=DEFAULT`)
    return this.http.get(this.apigetSeason);
  }

  /* getSeasons(): Observable<any> {
    return this.http.get<any>(this.apigetSeason);
  } */

  getReturnDetails(locId: string, orderSeason: string): Observable<any> {
    this.apigetReturnbyLocation = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders`)
    const url = `${this.apigetReturnbyLocation}/getReturnsByLoc/${orderSeason}?fields=DEFAULT&locId=${locId}&isSearchByProfile=${this.getIsSearchByProfile()}`;
    return this.http.get<any>(url);
  }

  noReturns(soldToID: string, locIDs: string[],defaultseason:string): Observable<any> {
    const payload = {
      soldToID: soldToID,
      season: defaultseason,
      shipToIdList: locIDs.map(locID => ({ shipToId: locID }))
    };
    this.apiNoreturnUrl = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/noReturnSubmit?fields=DEFAULT"`);
    
    return this.http.post(this.apiNoreturnUrl, payload, { responseType: 'text' }).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    //console.error('An error occurred:', error.message);
    //console.error('Error details:', error); // Log detailed error information
    return throwError('Something went wrong; please try again later.');
  }

  

  submitReturns(payload: any): Observable<any> {
    const url = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/submitUKReturns?fields=DEFAULT`);
    return this.http.post(url, payload, {
      headers: {
        'Content-Type': 'application/json'
      },
      responseType: 'text' as 'json' // Specify the response type as text
    }).pipe(
      catchError(this.handleError) // Handle errors
    );
  }

  
  postProductsToReturn(locIDs: string[],defaultseason:string): Observable<any> {
    const payload = {
      locations: locIDs.map(locID => ({ locationId: locID })),
      season: defaultseason,
    };
    this.apiProductstoreturn = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/productsToReturn?fields=DEFAULT`);
    
    return this.http.post(this.apiProductstoreturn, payload, { responseType: 'json' }).pipe(
      catchError(this.handleError)
    );
  }

 

  getImages(locationID: string): GalleryImage[] {
    if (!this.locationImages[locationID]) {
      this.locationImages[locationID] = [];
    }
    return this.locationImages[locationID];
  }

 /*  addImage(locationID: string, image: GalleryImage): void {
    if (!this.locationImages[locationID]) {
      this.locationImages[locationID] = [];
    }
    
const list = this.getImages(locationID);
const exists = list.some(i => i.name === image.name && i.src === image.src);
if (exists) return;

    console.log("hello")
    this.locationImages[locationID].push(image);
    console.log(this.locationImages)
  } */
 
private ensureLocation(locationID: string) {
  if (!this.locationImages[locationID]) this.locationImages[locationID] = [];
  if (!this.locationImageKeys[locationID]) this.locationImageKeys[locationID] = new Set<string>();
}

 
private imageKey(img: GalleryImage) {
  // pick a robust key — adjust if you can compute a content hash
  return `${img.name}|${img.src}`;
}

addImage(locationID: string, image: GalleryImage): void {
  this.ensureLocation(locationID);

  const key = this.imageKey(image);
  const keys = this.locationImageKeys[locationID];

  // Atomically guard; no race between exists() and push()
  if (keys.has(key)) return;

  // mark first, then append
  keys.add(key);

  // use immutable update to avoid accidental shared mutations
  const current = this.locationImages[locationID];

  this.locationImages[locationID] = [...current, image];
}


  
  removeImage(locationID: string, index: number): void {
    if (this.locationImages[locationID]) {
      this.ensureLocation(locationID);
      const image = this.locationImages[locationID][index];
      
    
      const key = this.imageKey(image);
    
      this.locationImageKeys[locationID].delete(key);
      this.locationImages[locationID].splice(index, 1);
    
    
    }
  }
  


  // New methods for File objects
getImageFiles(locationID: string): File[] {
  if (!this.locationImageFiles[locationID]) {
    this.locationImageFiles[locationID] = [];
  }
  return this.locationImageFiles[locationID];
}

addImageFile(locationID: string, file: File): void {
  if (!this.locationImageFiles[locationID]) {
    this.locationImageFiles[locationID] = [];
  }
  this.locationImageFiles[locationID].push(file);
}

removeImageFile(locationID: string, index: number): void {
  if (this.locationImageFiles[locationID]) {
    this.locationImageFiles[locationID].splice(index, 1);
  }
}

submitImages(formData: FormData): Observable<any> {
  const url = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/imageUploadReturns?fields=DEFAULT`);
  return this.http.post(url, formData, { responseType: 'text' }).pipe(
    catchError(this.handleError)
  );
  
}


private locnameSource = new BehaviorSubject<string>('');
currentLocname = this.locnameSource.asObservable();

changeLocname(locname: string) {
  this.locnameSource.next(locname);
}
private visibilityState = new BehaviorSubject<string>('A');
  currentVisibility = this.visibilityState.asObservable();
  changeVisibility(component: string) {
    this.visibilityState.next(component);
  }
  setReturnFailurePopup(result: boolean){
    this.showSorryMsg$.next(result);
  }
  getReturnFailurePopup(){
    return this.showSorryMsg$.asObservable();
  }
  registerReturn(consentValue: boolean):Observable<any>{
    // const url = this.occ.buildUrl(`${this.fetchUserUrl()}/returnsOrders/submitRegisterInterest`);
    const url = this.occ.buildUrl(`${this.fetchUserUrl()}/my-profile/marketingconsent/${consentValue}`);
    return this.http.post(url,{headers:{ responseType: 'text' }})
  }

  
public async urlToFile(imageUrl:string, filename:string) {
  const res = await fetch(imageUrl);
  //if (!res.ok) throw new Error(`Failed to fetch image: ${res.status}`);

  const blob = await res.blob();

  // Try to infer extension from content-type
  const contentType = blob.type || "image/jpeg";
  //const ext = contentType.split("/")[1] || "jpg";
  const fileext=filename.split('.')[2];

  const finalName = filename.includes(".") ? filename : `${filename}`;

  return new File([blob], finalName, { type: contentType });
}

  ngOnDestroy(): void {
    this.visibilityState.next("");
    this.visibilityState.complete();
  }
}

